import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Hero from '../../components/Home/Home';
import About from '../../components/About/About';
import Experience from '../../components/Experience/Experience';
import Services from '../../components/Services/Services';
import Team from '../../components/Team/Team';
import Reviews from '../../components/Reviews/Reviews';
import FadeInSection from '../../components/Animation/FadeInSection';

const HomeContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  opacity: ${props => props.$loaded ? 1 : 0};
  transition: opacity 0.8s ease-in-out;
`;

const HomePage = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <HomeContainer $loaded={loaded}>
      <Hero id="home" />
      
      <FadeInSection>
        <About id="about" />
      </FadeInSection>
      
      <FadeInSection delay="0.1s">
        <Experience id="experience" />
      </FadeInSection>
      
      <FadeInSection delay="0.2s">
        <Services id="services" />
      </FadeInSection>
      
      <FadeInSection delay="0.3s">
        <Reviews id="reviews" />
      </FadeInSection>
      
      <FadeInSection delay="0.4s">
        <Team id="team" />
      </FadeInSection>
    </HomeContainer>
  );
};

export default HomePage;
